import { DefaultLayout } from "../../components";
import styled from "styled-components";
import { useEffect, useMemo, useState } from "react";
import { IEtrmConfig } from "../../services";
import React from "react";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../store";
import { IApplicationState } from "../../store";
import { BaseTable, Button } from "@sede-enterprise/shell-ds-react-framework";
import { FetchEtrmConfigAction } from "../../store/EtrmConfig/ActionCreator";
import { EditEtrmConfigEntity } from "./EditEtrmConfigEntity";
import { AddEtrmConfigEntity } from "./AddEtrmConfigEntity";
import { LoadingIndicator } from "../../components/LoadingIndicator/LoadingIndicator";
import { CheckForEtrmConfiguration } from "../../helper/disabled-button";
import { CellInfo } from "../../core/types";
interface IEtrmConfigProps {}

const ButtonStyled = styled(Button)`
  min-height: 25px;
`;
const TableContainer = styled.div`
  margin: 16px;
  height: calc(100vh - 180px);
  background: ${({ theme }) => theme.background};
`;
const TableStyled = styled(BaseTable)`
  width: 100%;
  
  th, td {
    padding: 8px 16px;
    white-space: nowrap;
    background: ${({ theme }) => theme.background};
  }

  thead tr {
    position: sticky;
    top: 0;
    z-index: 1;
    background: ${({ theme }) => theme.background};
  }
`;
export const AddNewDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: -50px;
  margin-bottom: 10px;
  margin-right: 30px;
`;

const EtrmConfig: React.FC<IEtrmConfigProps> = (props) => {
  const dispatch = useAppDispatch();
  const size = useWindowSize();
  const isLoading = useSelector((state: IApplicationState) => state.etrmconfig.loading);
  const exceptionMessage = useSelector((state: IApplicationState) => state.etrmconfig.exceptionMessage);
  let postEtrmConfigSuccess = useSelector((state: IApplicationState) => state.etrmconfig.isEtrmConfigPostSuccess);
  const profilePage = useSelector((state: IApplicationState) => state.profile.profile);
  const data = useSelector((state: IApplicationState) => state.etrmconfig.etrmConfigs);
  const rowData = useMemo(() => data || [], [data]);
  const [alertMessage, setAlertMessage] = useState("");
  
  const calculateMaxHeight = () => {
    return window.innerHeight - 160;
  };

  const calculateMaxWidth = () => {
    return window.innerWidth;
  };

  const [maxHeight, setMaxHeight] = useState(calculateMaxHeight());
  const [maxWidth, setMaxWidth] = useState(calculateMaxWidth());

  useEffect(() => {
    dispatch(FetchEtrmConfigAction());
  }, []);

  useEffect(() => {
    if (exceptionMessage) {
      setAlertMessage(exceptionMessage);
    }
  }, [exceptionMessage]);

  const renderValue = (value: any) => {
    return <div>{value}</div>;
  };

  const renderEditButton = (value: any) => {
    return (
      <ButtonStyled
        type="button"
        disabled={CheckForEtrmConfiguration(profilePage)}
        variant="outlined"
        onClick={() => onClickEdit(value)}
        size="xsmall"
      >
        {" "}
        Edit
      </ButtonStyled>
    );
  };
  const etrmConfigColumns = () => [
    {
      header: "Corridor Code",
      accessorKey: "corridorCode",
      fixed: "left",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Out Area Eic Code",
      accessorKey: "outAreaEicCode",
      width: 120,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "In Area Eic Code",
      accessorKey: "inAreaEicCode",
      width: 120,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Currency",
      accessorKey: "currency",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Import Type",
      accessorKey: "importType",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Audit Type",
      accessorKey: "auditType",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Trade Type2",
      accessorKey: "tradeType2",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Buy Sell",
      accessorKey: "buySell",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Opt Type",
      accessorKey: "optType",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Mkt1",
      accessorKey: "mkt1",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Mkt2",
      accessorKey: "mkt2",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Comp1",
      accessorKey: "comp1",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Comp2",
      accessorKey: "comp2",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Book",
      accessorKey: "book",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Firm Type",
      accessorKey: "firmType",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Schedule",
      accessorKey: "schedule",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Broker",
      accessorKey: "broker",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Trader",
      accessorKey: "trader",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Contract",
      accessorKey: "contract",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Unit",
      accessorKey: "unit",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Period",
      accessorKey: "period",
      width: 100,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Days",
      accessorKey: "days",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "Timezone",
      accessorKey: "timezone",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "TGroup1",
      accessorKey: "tGroup1",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "TGroup4",
      accessorKey: "tGroup4",
      width: 70,
      cell: (info: CellInfo) => renderValue(info.getValue())
    },
    {
      header: "",
      accessorKey: "id",
      key: "",
      width: 70,
      cell: (info: CellInfo) => renderEditButton(info.row.original)
    },
  ];


  const transformedColumns = etrmConfigColumns();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showAddNewModal, setShowAddNewModal] = useState<boolean>(false);
  const [selectedEtrmConfig, setSelectedEtrmConfig] =
    useState<IEtrmConfig | null>(null);
  const onClickEdit = (etrmConfig: IEtrmConfig) => {
    setSelectedEtrmConfig(etrmConfig);
    setShowModal(true);
  };
  const onClickAddNew = () => {
    setShowAddNewModal(true);
  };

  useEffect(() => {
    if (postEtrmConfigSuccess) {
      dispatch(FetchEtrmConfigAction());
    }
  }, [postEtrmConfigSuccess]);

  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(calculateMaxHeight());
      setMaxWidth(calculateMaxWidth());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div data-testid="EtrmConfig">
      <DefaultLayout
        title="ETRM Config"
        message={alertMessage}
        children={
          isLoading ? (
            <LoadingIndicator />
          ) : (
            <>
              <AddNewDiv>
                <Button
                  type="button"
                  disabled={CheckForEtrmConfiguration(profilePage)}
                  size="small"
                  onClick={() => onClickAddNew()}
                >
                  {" "}
                  Add New
                </Button>
              </AddNewDiv>
              <TableContainer>
                <TableStyled
                  data-testid="EtrmConfigTable"
                  data={rowData}
                  columns={etrmConfigColumns()}
                  key="corridorCode"
                  size="small"
                  stickyHeader={true}
                  maxHeight={maxHeight}
                  maxWidth={maxWidth}
                />
              </TableContainer>

              {showModal && selectedEtrmConfig && (
                <EditEtrmConfigEntity
                  etrmConfig={selectedEtrmConfig}
                  onCancel={() => {
                    setShowModal(false);
                  }}
                />
              )}
              {showAddNewModal && (
                <AddEtrmConfigEntity
                  onCancel={() => {
                    setShowAddNewModal(false);
                  }}
                />
              )}
            </>
          )
        }
      />
    </div>
  );
};
export default EtrmConfig;
